// myfrontend/src/components/OwnerForm.js
import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../static/form.css';
import '../static/modals.scss';
import '../static/SignaturePad.css';
import PetForm from './PetForm';



const OwnerForm = () => {
    const [name, setName] = useState('');
    const [phoneMobile, setPhoneMobile] = useState('');
    const [email, setEmail] = useState('');
    const [postcode, setPostcode] = useState('London');
    const [address, setAddress] = useState('');
    const [points, setPoints] = useState(0);
    const [numberOfVisit, setNumberOfVisit] = useState(0);
    const [note, setNote] = useState('');
    const [signature, setSignature] = useState(null);
    
    const navigate = useNavigate();
    

    const handleSubmit = async (e) => {
       
        e.preventDefault();
        const formData = new FormData();
        formData.append('name', name);
        formData.append('phone_mobile', phoneMobile);
        formData.append('email', email);
        formData.append('postcode', postcode);
        formData.append('address', address);
        formData.append('points', points);
        formData.append('numberofvisit', numberOfVisit);
        formData.append('note', note);
        if (signature) {
            formData.append('signature', signature);
        }

        try {
       const response = await axios.post('/create-owner/', formData);

        // ✅ Navigate only after successful POST
         console.log('Response:', response.data);

      // ✅ Navigate only after successful POST
        navigate('/petscreate', {
            state: {
                owner: {
                id: response.data.id,
                phone: response.data.phone,
                email: response.data.email
                }
            }
            });
        }catch (error) {
                console.error('Error submitting owner form:', error);
        }
    };

    return (
        <section className="contact-wrap">
            <form onSubmit={handleSubmit} className="contact-form" encType="multipart/form-data">
                <label>Name:</label>
                <div className="input-block">
                    <input type="text" value={name} onChange={(e) => setName(e.target.value)} required className="form-control" />
                </div>

                <label>Mobile Phone:</label>
                <div className="input-block">
                    <input type="text" value={phoneMobile} onChange={(e) => setPhoneMobile(e.target.value)} required className="form-control" />
                </div>

                <label>Email:</label>
                <div className="input-block">
                    <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="form-control" />
                </div>

                <label>Postcode:</label>
                <div className="input-block">
                    <input type="text" value={postcode} onChange={(e) => setPostcode(e.target.value)} className="form-control" />
                </div>

                <label>Address:</label>
                <div className="input-block">
                    <textarea value={address} onChange={(e) => setAddress(e.target.value)} className="form-control" rows="2" />
                </div>
                <button type="submit" className="square-button">Submit Owner Info</button>
            </form>
        </section>
    );
};

export default OwnerForm;
